// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  restaurantId: __t.u64(),
  furnitureUid: __t.string(),
  defId: __t.string(),
  plates: __t.u32(),
  glasses: __t.u32(),
  cycleTimeRemainingMs: __t.i64(),
  platesTiers: __t.string(),
  glassesTiers: __t.string(),
};
